import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'

export default class Register extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="reg">
                    <div className="container">
                        <div className="cont">
                            <form action="">
                                <input type="text" placeholder='UserName' />
                                <input type="email" placeholder='Email' />
                                <input type="password" placeholder='Password' />
                                <button>Register</button>
                                <NavLink to="/login">I Have Account <strong>Login</strong></NavLink>
                            </form>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
